import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import urlName from '../url-name';
import { StaticContents } from 'components/ServerSideComponents.jsx';
import { facebookLogo, link, twitterLogo } from './images';

import styles from '../scss/components/share-tools.scss';

/*
 * The social share icons that are below each entry
 */
export default class ShareTools extends Component {
	onClick(type) {
		this.props.ga.event('Interactives: The Root 100 - 2019', `Entry Interaction: ${type} share`, {eventLabel: this.props.name});
	}

	render() {
		const { name, rank } = this.props;
		const parameterizedName = urlName(name);
		const shareUrl = `http://interactives.theroot.com/root-100-2019/${parameterizedName}/`;
		const person = `${rank}: ${name}`;
		const tweetText = `The Root 100 - The Most Influential African Americans in 2019 - ${person} - ${shareUrl}`;

		return (
			<div className={styles.shareTools}>
				<a href={`https://twitter.com/intent/tweet?text=${tweetText}`} onClick={() => this.onClick('Twitter')}>
					<StaticContents>
						<div className={classNames(styles.shareTool, styles.twitter)}>
							{twitterLogo}
						</div>
					</StaticContents>
				</a>

				<a href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`} onClick={() => this.onClick('Facebook')}>
					<StaticContents>
						<div className={classNames(styles.shareTool, styles.facebook)}>
							{facebookLogo}
						</div>
					</StaticContents>
				</a>

				<CopyToClipboard text={`https://interactives.theroot.com/root-100-2019/${this.props.nameHash}`} onCopy={() => this.onClick('Link')}>
					<div>
						<StaticContents>
							<div className={classNames(styles.shareTool, styles.link)}>
								{link}
							</div>
						</StaticContents>
					</div>
				</CopyToClipboard>
			</div>
		);
	}
}

ShareTools.propTypes = {
	name: PropTypes.string.isRequired,
	rank: PropTypes.number.isRequired,
	twitterAccount: PropTypes.string
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/share-tools.js